import script from "./product-introduce.vue?vue&type=script&setup=true&lang=js"
export * from "./product-introduce.vue?vue&type=script&setup=true&lang=js"

import "./product-introduce.vue?vue&type=style&index=0&id=54ab6bc8&scoped=true&lang=less"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ab6bc8"]])

export default __exports__